"use strict";
const publicMount = document.querySelector("#public-app");
const pApiOrigin = publicMount.dataset.apiOrigin || "",
  pCatalogBase = publicMount.dataset.catalogBase || "/catalog/";
const pLogoURL =
  publicMount.dataset.logoUrl ||
  "https://smartwholesale.net/cdn/shop/t/14/assets/smart-wholesale-logo-a.png?v=77236021721133858991792391674";
document.addEventListener(
  "error",
  (e) => {
    if (e.target?.matches?.(".brand-logo"))
      e.target.closest(".wordmark")?.classList.add("brand-image-unavailable");
  },
  true,
);
function productHref(id) {
  const u = new URL(
    pApiOrigin ? pCatalogBase : "/catalog/product/" + id,
    location.origin,
  );
  if (pApiOrigin) u.searchParams.set("product", id);
  const preview = new URLSearchParams(location.search).get("preview_theme_id");
  if (preview) u.searchParams.set("preview_theme_id", preview);
  return u.pathname + u.search;
}
const pub = {
  lang: localStorage.getItem("la-public-language") === "zh" ? "zh" : "en",
  config: null,
  items: [],
  offset: 0,
  query: "",
  product: null,
  book: null,
  busy: false,
  pending: null,
  manage: null,
  categories: [],
  category: "",
  sort: "name",
  inStock: false,
  total: 0,
};
const $p = (s) => document.querySelector(s),
  pe = (v) =>
    String(v ?? "").replace(
      /[&<>"']/g,
      (c) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[c],
    );
const pw = {
  products: ["Products", "商品"],
  contact: ["Contact & visits", "联系与到访"],
  text: ["Text us about this item", "短信咨询此商品"],
  call: ["Call the store", "致电门店"],
  book: ["Book an appointment", "预约到访"],
  hero: ["Good products.\nA closer look.", "发现商品，\n近距离了解。"],
  intro: [
    "Browse our products, check available quantities, and talk with our team.",
    "浏览商品、查看可用数量，直接联系我们的团队。",
  ],
  eyebrow: ["SMART WHOLESALE / IN-STORE FINDS", "SMART WHOLESALE / 门店商品"],
  visit: ["Let’s arrange a visit.", "预约，亲自了解。"],
  visit_help: [
    "See something you like? Text or call us, or choose an appointment time.",
    "看中商品？欢迎短信或电话联系，也可以选择预约时间。",
  ],
  hours: ["Business hours", "营业时间"],
  timezone: [
    "All hours and appointments use Los Angeles time.",
    "营业及预约时间均为洛杉矶时间。",
  ],
  closed: ["Closed", "休息"],
  not_set: [
    "Details are being prepared. Please check back.",
    "详细资料正在准备中，请稍后查看。",
  ],
  search: ["Name, brand, model or SKU", "名称、品牌、型号或SKU"],
  find: ["Find", "查找"],
  available: ["Available", "可用"],
  units: ["units", "件"],
  cases: ["full cases", "整箱"],
  loose: ["loose units", "散件"],
  checked: ["Availability checked", "库存查询时间"],
  stock_note: [
    "Availability can change. Contacting us or booking a visit does not reserve products.",
    "库存可能变化。咨询或预约到访不会预留商品。",
  ],
  view: ["View product", "查看商品"],
  none: ["Products are being prepared", "商品正在准备中"],
  none_help: [
    "Approved products will appear here.",
    "审核后的商品将在此显示。",
  ],
  no_matches: ["No matching products", "没有匹配的商品"],
  clear: ["Clear search", "清除搜索"],
  more: ["Load more products", "加载更多商品"],
  back: ["Back to products", "返回商品目录"],
  no_photo: ["Product photo coming soon", "商品照片待添加"],
  model: ["Model", "型号"],
  brand: ["Brand", "品牌"],
  case_size: ["Units per case", "每箱件数"],
  staff: ["Staff sign in", "员工登录"],
  loading: ["Loading…", "加载中…"],
  retry: ["Try again", "重试"],
  close: ["Close", "关闭"],
  date: ["Choose a date", "选择日期"],
  time: ["Choose a time", "选择时间"],
  name: ["Your name", "您的姓名"],
  phone: ["Mobile number with country code", "手机号（含国家代码）"],
  reason: [
    "Product or reason for visit (optional)",
    "感兴趣的商品或到访事由（选填）",
  ],
  consent: [
    "You may contact me about this appointment. This is not marketing consent.",
    "同意就本次预约联系我，不代表同意营销信息。",
  ],
  privacy: [
    "Your contact details are private and used to manage this appointment.",
    "您的联系资料保密，仅用于处理本次预约。",
  ],
  review: ["Review appointment", "核对预约"],
  submit: ["Submit appointment", "提交预约"],
  edit: ["Back to edit", "返回修改"],
  required: ["Required", "必填"],
  slot_none: [
    "No appointment times available on this date. Try another date.",
    "该日期没有可预约时间，请选择其他日期。",
  ],
  booking_off: [
    "Online booking is being prepared. Please contact us to arrange a visit.",
    "线上预约正在准备中，请联系我们安排到访。",
  ],
  request: ["Appointment requested", "预约申请已提交"],
  confirmed: ["Appointment confirmed", "预约已确认"],
  cancelled: ["Appointment cancelled", "预约已取消"],
  pending_help: [
    "Our team must confirm this request. Your visit is not confirmed yet.",
    "此申请需要团队确认，目前尚未确认到访。",
  ],
  no_sms: [
    "No text message has been sent. Save the private management link below.",
    "尚未发送短信，请保存下方私密预约管理链接。",
  ],
  manage: ["Manage this appointment", "管理本次预约"],
  reference: ["Reference", "预约编号"],
  cancel: ["Cancel appointment", "取消预约"],
  reschedule: ["Reschedule", "更改时间"],
  cancel_question: ["Cancel this appointment?", "确定取消本次预约？"],
  private: [
    "Keep this link private. Anyone with it can manage your appointment.",
    "请保密此链接，持有链接的人可以管理您的预约。",
  ],
  copy: ["Copy private link", "复制私密链接"],
  copied: ["Link copied", "链接已复制"],
  unknown: [
    "The result is unknown. Keep this page open and retry the same submission.",
    "结果未知，请保留页面并重试同一次提交。",
  ],
  discard: [
    "Discard your unfinished appointment details?",
    "放弃尚未提交的预约资料吗？",
  ],
  not_found: [
    "This product is not available on the website.",
    "该商品目前未在网站展示。",
  ],
};
const pt = (k) => (pw[k] || [k, k])[pub.lang === "zh" ? 1 : 0],
  pv = (o, k) => o[k + "_" + pub.lang] || o[k + "_en"] || o[k + "_zh"] || "",
  pb = (key, action, cls = "", extra = "") =>
    `<button type="button" data-pub="${action}" class="${cls}" ${extra}>${pe(pt(key))}</button>`;
const perrors = {
  phone_format: [
    "Use a country code, for example +1 followed by your number.",
    "请填写国家代码，例如+1后接手机号。",
  ],
  slot_unavailable: [
    "That time is no longer available. Choose another time.",
    "该时段已不可预约，请选择其他时间。",
  ],
  record_changed: [
    "This appointment changed. Reload it before continuing.",
    "预约资料已变动，请重新加载后操作。",
  ],
  too_many_requests: [
    "Too many requests. Please wait and try again or call us.",
    "请求过多，请稍后重试或电话联系。",
  ],
  contact_consent_required: [
    "Please confirm that we may contact you about this appointment.",
    "请确认同意就本次预约联系您。",
  ],
  appointment_closed: [
    "This appointment can no longer be changed online. Please contact us.",
    "此预约无法再在线修改，请联系我们。",
  ],
  booking_setup_required: [
    "Online booking is not ready. Please contact us.",
    "线上预约尚未开放，请联系我们。",
  ],
};
async function pa(path, body) {
  if(location.pathname==='/catalog/preview/'&&body)throw new Error(pub.lang==='zh'?'这是未公开的预览，请返回后操作。':'This is a private preview. Return to the app to make changes.');
  let r;
  try {
    r = await fetch(pApiOrigin + path, {
      method: body ? "POST" : "GET",
      credentials: "omit",
      headers: body ? { "Content-Type": "application/json" } : {},
      cache: "no-store",
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await r.json();
    if (!r.ok) {
      const e = new Error(
        (perrors[data.error] || [
          data.error === "not_found"
            ? pt("not_found")
            : "Please check your information and try again.",
          data.error === "not_found" ? pt("not_found") : "请检查资料后重试。",
        ])[pub.lang === "zh" ? 1 : 0],
      );
      e.code = data.error;
      throw e;
    }
    if (pApiOrigin) {
      const fix = (p) => {
        if (p.images)
          p.images = p.images.map((im) => ({
            url: pApiOrigin + im.url,
            thumb: pApiOrigin + im.thumb,
          }));
        return p;
      };
      if (data.products) data.products = data.products.map(fix);
      else fix(data);
    }
    return data;
  } catch (e) {
    if (e instanceof TypeError || e instanceof SyntaxError) {
      const err = new Error(pt("unknown"));
      err.unknown = !!body;
      throw err;
    }
    throw e;
  }
}
function dateLA(ts) {
  return new Intl.DateTimeFormat(pub.lang === "zh" ? "zh-CN" : "en-US", {
    timeZone: "America/Los_Angeles",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(ts * 1000));
}
function contactButtons(product, includeBook = true) {
  const c=pub.config,p=c.phone||"",title=product?pv(product,"title"):"";
  const link=product&&/^[a-f0-9]{20}$/.test(product.id)?new URL(productHref(product.id),location.origin).href:"";
  const msg=product?`Hello, I’m interested in ${title} (SKU: ${product.sku}). Is it available to buy in store? ${link}`:"";
  const apple=/iPad|iPhone|iPod/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  const sms="sms:"+p+(msg?(apple?"&body=":"?body=")+encodeURIComponent(msg):"");
  return `<div class="actions contact-actions">${p?`${c.sms_enabled?`<a class="button primary" href="${pe(sms)}">${pe(product?pt("text"):pub.lang==='zh'?'发短信':'Text the store')}</a>`:''}<a class="button ${c.sms_enabled?'':'primary'}" href="tel:${pe(p)}">${pe(pt("call"))}</a>`:''}${includeBook&&c.booking_enabled?pb("book","book","accent",product?`data-interest="${pe(title+' / '+product.sku)}"`:''):''}</div>${p?`<div class="contact-number"><a href="tel:${pe(p)}">${pe(p)}</a><button type="button" data-pub="copy-store-number">${pe(pub.lang==='zh'?'复制号码':'Copy number')}</button><span id="phone-copy-status" role="status"></span></div>`:`<p class="small muted">${pe(pt("not_set"))}</p>`}${!product&&(c.address||c.address_zh)?`<a class="button" target="_blank" rel="noopener" href="https://www.google.com/maps/search/?api=1&amp;query=${encodeURIComponent(c.address||c.address_zh)}">${pe(pub.lang==='zh'?'查看路线':'Get directions')}</a>`:''}`;
}
function productContact(product){
  return `<section class="product-contact" aria-label="${pe(pub.lang==='zh'?'购买咨询':'Contact us about this item')}"><h2>${pe(pub.lang==='zh'?'想购买这件商品？':'Interested in this item?')}</h2><p>${pe(pub.lang==='zh'?'短信或电话联系我们，询问商品并安排到店购买。':'Text or call us to ask about this product and arrange your store visit.')}</p>${contactButtons(product)}</section>`;
}
function businessHours() {
  const c = pub.config;
  if (!c.hours_confirmed && !c.business_hours.some((h) => h.length) && !c.appointment_only_days?.length)
    return `<p class="muted">${pe(pt("not_set"))}</p><p class="small muted">${pe(pt("timezone"))}</p>`;
  const names =
    pub.lang === "zh"
      ? ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
      : [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];
  return `<div class="hours">${c.business_hours.map((h, i) => `<div><span>${names[i]}</span><span>${c.appointment_only_days?.includes(i) ? pe(pub.lang === "zh" ? "仅限预约" : "By appointment") : h.length ? pe(h.join(" – ")) : pe(pt("closed"))}</span></div>`).join("")}</div>${c.closures.length ? `<p class="small">${pe(pub.lang === "zh" ? "临时休息日期：" : "Closed on: ")}${pe(c.closures.join(", "))}</p>` : ""}<p class="small muted">${pe(pt("timezone"))}</p>`;
}
function frame(content) {
  const c = pub.config,
    name =
      pub.lang === "zh"
        ? c.business_name_zh || c.business_name
        : c.business_name;
  $p("#public-app").innerHTML =
    `<div class="store-strip"><div class="wrap"><span>${pe(pub.lang === "zh" ? "先浏览商品，再到店购买" : "Browse online. Buy in store.")}</span><a href="#contact">${pe(pub.lang === "zh" ? "计划到访" : "Plan your visit")} ↗</a></div></div><header class="masthead"><div class="wrap"><a class="wordmark wordmark-with-logo" href="${pe(pCatalogBase)}"><img class="brand-logo" src="${pe(pLogoURL)}" alt="" width="176" height="88" decoding="async"><span class="brand-name">${pe(name)}</span></a><form id="public-search" class="search main-search"><input name="q" type="search" aria-label="${pe(pt("search"))}" placeholder="${pe(pub.lang === "zh" ? "搜索商品、品牌、型号或SKU" : "Search products, brands, models or SKUs")}" value="${pe(pub.query)}" maxlength="160"><button class="primary">${pe(pt("find"))} <span aria-hidden="true">⌕</span></button></form><nav class="navlinks"><a href="#contact"><span class="small">${pe(pub.lang === "zh" ? "欢迎联系" : "Let’s talk")}</span><strong>${pe(pub.lang === "zh" ? "联系与到访" : "Contact & visit")} ↗</strong></a></nav></div></header><div class="department-bar"><div class="wrap"><button data-pub="department" data-category="" class="${!pub.category ? "selected" : ""}">☰ ${pe(pub.lang === "zh" ? "全部商品" : "All products")}</button>${pub.categories
      .slice(0, 7)
      .map(
        (c) =>
          `<button data-pub="department" data-category="${pe(c)}" class="${pub.category === c ? "selected" : ""}">${pe(c)}</button>`,
      )
      .join(
        "",
      )}<a href="#contact">${pe(pt("hours"))}</a></div></div><main class="wrap">${content}<section class="contact-section" id="contact"><div><p class="eyebrow">${pe(pt("contact"))}</p><h2>${pe(pt("visit"))}</h2>${c.address || c.address_zh ? `<p>${pe(pub.lang === "zh" ? c.address_zh || c.address : c.address || c.address_zh)}</p>` : ""}<p>${pe(pv(c, "instructions"))}</p>${contactButtons(null)}</div><div><h3>${pe(pt("hours"))}</h3>${businessHours()}</div></section></main><footer class="footer"><div class="wrap"><span>${pe(name)} · ${pe(pt("stock_note"))}</span><details class="language-menu"><summary>${pub.lang === "zh" ? "语言：简体中文" : "Language: English"}</summary>${pb(pub.lang === "en" ? "简体中文" : "English", "language", "lang")}</details><a href="${pe(pApiOrigin || "")}/">${pe(pt("staff"))}</a></div></footer>`;
  document.documentElement.lang = pub.lang === "zh" ? "zh-CN" : "en";
  document.title = pub.product
    ? pv(pub.product, "title") + " | " + name
    : name + " | " + pt("products");
}
function availability(p) {
  const full = Math.floor(p.available / p.units_per_case),
    loose = p.available % p.units_per_case;
  return `<p><span class="quantity">${pe(pt("available"))}: ${p.available.toLocaleString()} ${pe(pt("units"))}</span></p>${p.units_per_case > 1 ? `<p class="small muted">${full} ${pe(pt("cases"))} + ${loose} ${pe(pt("loose"))}</p>` : ""}`;
}
function card(p) {
  const image = p.images[p.main_index];
  return `<article class="product-card"><a href="${pe(productHref(p.id))}">${image ? `<img src="${pe(image.thumb)}" alt="${pe(pv(p, "title"))}" loading="lazy" width="400" height="400">` : `<div class="no-photo">${pe(pt("no_photo"))}</div>`}<div class="product-content"><span class="sku">${pe(p.sku)}</span><h3>${pe(pv(p, "title"))}</h3>${suggestedPrice(p)}${availability(p)}</div></a><div class="actions"><a class="button" href="${pe(productHref(p.id))}">${pe(pt("view"))} →</a>${wholesaleButton(p)}</div></article>`;
}
function suggestedPrice(p) {
  return p.suggested_retail_cents == null
    ? `<p class="price-note">${pe(pub.lang === "zh" ? "联系询价" : "Contact us for pricing")}</p>`
    : `<p class="price-note">${pe(pub.lang === "zh" ? "建议零售价（每件）" : "Suggested retail price · each")}</p><p class="retail-price">${pe(new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(p.suggested_retail_cents / 100))}</p>`;
}
function wholesaleButton(p) {
  return `<button class="primary" type="button" data-pub="wholesale" data-product="${pe(p.id)}">${pe(pub.lang === "zh" ? "咨询批发价" : "Request wholesale pricing")}</button>`;
}
function renderCatalog() {
  pub.product = null;
  frame(
    `<section class="catalog-intro"><div><p class="eyebrow">${pe(pub.lang === "zh" ? "SMART WHOLESALE · 精选商品" : "SMART WHOLESALE · LOCAL FINDS")}</p><h1>${pub.lang === "zh" ? "值得亲自来看看。" : "Your next great find starts here."}</h1><p>${pe(pub.lang === "zh" ? "看看有什么，查查数量，再安排到店。" : "See what’s here, check availability, and plan a visit.")}</p></div><a class="intro-visit" href="#contact">${pe(pub.lang === "zh" ? "看看营业时间" : "Come take a closer look")} <span aria-hidden="true">↗</span></a></section><section id="products"><div class="results-heading"><h2>${pe(pub.category || (pub.lang === "zh" ? "浏览商品" : "Explore the inventory"))}</h2><span class="small muted">${pub.total} ${pub.lang === "zh" ? "个商品" : "products"}</span></div><div class="browse-tools"><label>${pub.lang === "zh" ? "分类" : "Department"}<select id="public-category"><option value="">${pub.lang === "zh" ? "全部分类" : "All departments"}</option>${pub.categories.map((c) => `<option value="${pe(c)}" ${c === pub.category ? "selected" : ""}>${pe(c)}</option>`).join("")}</select></label><label>${pub.lang === "zh" ? "排序" : "Sort by"}<select id="public-sort">${[
      ["name", "Name, A–Z", "名称"],
      ["quantity", "Most available", "可用数量最多"],
      ["price_low", "Suggested price: low to high", "建议价从低到高"],
      ["price_high", "Suggested price: high to low", "建议价从高到低"],
    ]
      .map(
        ([v, en, zh]) =>
          `<option value="${v}" ${pub.sort === v ? "selected" : ""}>${pe(pub.lang === "zh" ? zh : en)}</option>`,
      )
      .join(
        "",
      )}</select></label><label class="stock-filter"><input type="checkbox" id="public-stock" ${pub.inStock ? "checked" : ""}>${pub.lang === "zh" ? "只看有货" : "In stock only"}</label><span class="small muted">${pub.total} ${pub.lang === "zh" ? "个结果" : "results"}</span></div><div id="public-results">${pub.items.length ? `<div class="catalog-grid">${pub.items.map(card).join("")}</div>` : `<div class="empty"><h3>${pe(pt(pub.query || pub.category ? "no_matches" : "none"))}</h3><p class="muted">${pe(pt("none_help"))}</p>${pub.query || pub.category ? pb("clear", "clear") : ""}</div>`}</div>${pub.offset !== null ? `<div class="load-more">${pb("more", "more")}</div>` : ""}<p class="small muted" id="availability-checked">${pe(pt("stock_note"))}</p></section>`,
  );
}
async function catalogFetch(more = false) {
  const sequence = (pub.sequence = (pub.sequence || 0) + 1);
  const r = await pa(
    "/api/public/products?q=" +
      encodeURIComponent(pub.query) +
      "&category=" +
      encodeURIComponent(pub.category) +
      "&sort=" +
      encodeURIComponent(pub.sort) +
      "&in_stock=" +
      (pub.inStock ? "1" : "0") +
      "&offset=" +
      (more ? pub.offset : 0),
  );
  if (sequence !== pub.sequence) return;
  pub.items = more ? [...pub.items, ...r.products] : r.products;
  pub.offset = r.next_offset;
  pub.categories = r.categories || [];
  pub.total = r.total ?? r.products.length;
  pub.catalogRevision = r.catalog_revision;
  renderCatalog();
  $p("#availability-checked").textContent =
    pt("checked") +
    ": " +
    dateLA(Date.parse(r.checked_at) / 1000) +
    ". " +
    pt("stock_note");
}
function renderProduct(p) {
  pub.product = p;
  const image = p.images[p.main_index];
  frame(
    `<a class="backlink" href="${pe(pCatalogBase)}">← ${pe(pt("back"))}</a><article class="product-detail"><div>${image ? `<img class="detail-photo" id="detail-photo" width="2048" height="2048" fetchpriority="high" decoding="async" src="${pe(image.url)}" alt="${pe(pv(p, "title"))}">` : `<div class="no-photo">${pe(pt("no_photo"))}</div>`}<div class="thumbs">${p.images.map((im, i) => `<button data-pub="photo" data-index="${i}" aria-label="${pe(pv(p, "title"))} ${i + 1}"><img src="${pe(im.thumb)}" alt=""></button>`).join("")}</div></div><div><span class="sku">${pe(p.sku)}</span><h1>${pe(pv(p, "title"))}</h1>${suggestedPrice(p)}${availability(p)}${productContact(p)}<p class="small muted">${pe(pt("checked"))}: ${pe(dateLA(Date.parse(p.checked_at) / 1000))}</p><p class="description">${pe(pv(p, "intro"))}</p><ul>${(p["bullets_" + pub.lang]?.length ? p["bullets_" + pub.lang] : p.bullets_en).map((v) => `<li>${pe(v)}</li>`).join("")}</ul><dl class="specs">${[
      ["brand", p.brand],
      ["model", p.model],
      ["case_size", p.units_per_case],
    ]
      .filter(([, v]) => v)
      .map(([k, v]) => `<div><dt>${pe(pt(k))}</dt><dd>${pe(v)}</dd></div>`)
      .join(
        "",
      )}</dl>${wholesaleButton(p)}<p class="small muted">${pe(pt("stock_note"))}</p></div></article>`,
  );
}
function bookingHead() {
  return `<div class="dialog-head"><h2>${pe(pt("book"))}</h2>${pb("close", "close-book")}</div><p class="small muted">${pe(pt("timezone"))}</p><p id="booking-error" class="notice error" role="alert" hidden></p>`;
}
function showBook(interest = "") {
  if (pub.pending) return;
  pub.book = {
    stage: 0,
    interest,
    name: "",
    phone: "",
    date: "",
    start: "",
    slots: [],
  };
  drawBook();
  lockRescheduleFields();
  $p("#booking-dialog").showModal();
}
function drawBook() {
  const b = pub.book,
    c = pub.config,
    body = $p("#booking-body");
  if (!c.booking_enabled) {
    body.innerHTML =
      bookingHead() +
      `<p class="notice">${pe(pt("booking_off"))}</p>` +
      contactButtons(null, false);
    return;
  }
  const summary = b.start ? dateLA(Number(b.start)) : "";
  body.innerHTML =
    bookingHead() +
    (b.stage === 1
      ? `<div class="booking-summary">${pe(b.name)}\n${pe(b.phone)}\n${pe(summary)}\n${pe(b.interest)}</div><p>${pe(c.approval_required ? pt("pending_help") : pt("confirmed"))}</p><div class="form-actions">${pb("edit", "book-back")}${pb("submit", "book-send", "primary")}</div>`
      : `<form id="public-book-form"><label>${pe(pt("date"))} · ${pe(pt("required"))}<input name="date" type="date" value="${pe(b.date)}" required></label><label>${pe(pt("time"))} · ${pe(pt("required"))}<select name="start" required><option value="">${pe(pt("time"))}</option>${b.slots.map((s) => `<option value="${s.start}" ${String(s.start) === String(b.start) ? "selected" : ""}>${pe(dateLA(s.start))}</option>`).join("")}</select></label><p id="slot-message" class="small muted">${b.date && !b.slots.length ? pe(pt("slot_none")) : ""}</p><label>${pe(pt("name"))} · ${pe(pt("required"))}<input name="name" autocomplete="name" maxlength="100" required value="${pe(b.name)}"></label><label>${pe(pt("phone"))} · ${pe(pt("required"))}<input name="phone" type="tel" autocomplete="tel" placeholder="+1 …" maxlength="40" required value="${pe(b.phone)}"></label><label>${pe(pt("reason"))}<textarea name="interest" maxlength="300">${pe(b.interest)}</textarea></label><label class="honeypot" aria-hidden="true">Website<input name="website" tabindex="-1" autocomplete="off"></label><label class="check"><input type="checkbox" name="contact_consent" ${b.contact_consent ? "checked" : ""} required><span>${pe(pt("consent"))}</span></label><p class="small muted">${pe(pt("privacy"))}</p><div class="form-actions"><button class="primary">${pe(pt("review"))}</button></div></form>`);
}
function lockRescheduleFields() {
  if (pub.book?.rescheduling)
    for (const name of ["name", "phone", "interest"]) {
      const el = $p('#public-book-form [name="' + name + '"]');
      if (el) el.readOnly = true;
    }
}
function rememberBooking() {
  const f = $p("#public-book-form");
  if (f)
    Object.assign(pub.book, Object.fromEntries(new FormData(f)), {
      contact_consent: f.elements.contact_consent.checked,
    });
}
function bookError(e) {
  const el = $p("#booking-error");
  if (el) {
    el.hidden = false;
    el.textContent = e.message;
  } else $p("#public-status").textContent = e.message;
}
async function loadSlots(dateValue) {
  const b = pub.book;
  rememberBooking();
  const r = await pa("/api/public/slots?date=" + encodeURIComponent(dateValue));
  if (pub.book !== b || pub.book.date !== dateValue) return;
  b.slots = r.slots;
  b.start = "";
  drawBook();
  lockRescheduleFields();
}
function privateLink() {
  return (
    location.origin +
    pCatalogBase +
    "#booking=" +
    pub.manage.reference +
    ":" +
    pub.manage.manage_token
  );
}
function showConfirmation(r, token) {
  pub.pending = null;
  pub.book = null;
  pub.manage = { ...r, manage_token: token || pub.manage?.manage_token };
  history.replaceState(
    null,
    "",
    pCatalogBase + "#booking=" + r.reference + ":" + pub.manage.manage_token,
  );
  const c = pub.config;
  $p("#booking-body").innerHTML =
    bookingHead() +
    `<h3>${pe(pt(r.status === "requested" ? "request" : r.status === "cancelled" ? "cancelled" : "confirmed"))}</h3>${r.status === "requested" ? `<p class="notice">${pe(pt("pending_help"))}</p>` : ""}<p>${pe(pt("reference"))}: <b>${pe(r.reference)}</b></p><p>${pe(dateLA(r.start_utc))}</p><p>${pe(pub.lang === "zh" ? c.address_zh || c.address : c.address || c.address_zh)}</p><p>${pe(pv(c, "instructions"))}</p><p class="notice">${pe(pt("no_sms"))}</p><p class="small">${pe(pt("private"))}</p><p class="private-link">${pe(privateLink())}</p>${pb("copy", "copy-book")}<div class="form-actions">${r.status !== "cancelled" ? pb("reschedule", "reschedule") + pb("cancel", "cancel-book") : ""}</div>`;
  if (!$p("#booking-dialog").open) $p("#booking-dialog").showModal();
}
async function sendBooking() {
  if (pub.busy) return;
  pub.busy = true;
  try {
    if (!pub.pending)
      pub.pending = {
        name: pub.book.name,
        phone: pub.book.phone,
        interest: pub.book.interest,
        start: Number(pub.book.start),
        contact_consent: true,
        website: pub.book.website || "",
        idempotency_key: crypto.randomUUID(),
      };
    const r = await pa("/api/public/book", pub.pending);
    showConfirmation(r, r.manage_token);
  } catch (e) {
    if (!e.unknown) {
      pub.pending = null;
      if (e.code === "slot_unavailable") {
        pub.book.stage = 0;
        pub.book.start = "";
        drawBook();
      }
    }
    bookError(e);
  } finally {
    pub.busy = false;
  }
}
async function manageBooking(action, start) {
  if (pub.busy) return;
  pub.busy = true;
  try {
    const b = pub.manage;
    const r = await pa("/api/public/booking-manage", {
      reference: b.reference,
      manage_token: b.manage_token,
      expected_version: b.version,
      action,
      ...(start ? { start: Number(start) } : {}),
    });
    showConfirmation(r);
  } finally {
    pub.busy = false;
  }
}
document.addEventListener("click", async (e) => {
  const el = e.target.closest("[data-pub]");
  if (!el || el.disabled) return;
  try {
    const a = el.dataset.pub;
    if(a==='copy-store-number'){
      const number=pub.config.phone||'';
      try{await navigator.clipboard.writeText(number);el.textContent=pub.lang==='zh'?'已复制':'Copied'}catch(_){el.textContent=number;window.getSelection?.()?.selectAllChildren(el)}
      return;
    }
    if (a === "language") {
      pub.lang = pub.lang === "en" ? "zh" : "en";
      localStorage.setItem("la-public-language", pub.lang);
      if (pub.product) renderProduct(pub.product);
      else renderCatalog();
      return;
    }
    if (a === "book") showBook(el.dataset.interest || "");
    if (a === "close-book") {
      if (pub.pending) {
        bookError(new Error(pt("unknown")));
        return;
      }
      if (
        pub.book &&
        (pub.book.name || pub.book.phone) &&
        !confirm(pt("discard"))
      )
        return;
      $p("#booking-dialog").close();
    }
    if (a === "more") {
      el.disabled = true;
      await catalogFetch(true);
    }
    if (a === "clear") {
      pub.query = "";
      pub.category = "";
      pub.inStock = false;
      await catalogFetch();
    }
    if (a === "retry") await startPublic();
    if (a === "photo")
      $p("#detail-photo").src =
        pub.product.images[Number(el.dataset.index)].url;
    if (a === "book-back" && !pub.pending) {
      pub.book.stage = 0;
      drawBook();
      lockRescheduleFields();
    }
    if (a === "book-send") await sendBooking();
    if (a === "copy-book") {
      await navigator.clipboard.writeText(privateLink());
      $p("#public-status").textContent = pt("copied");
    }
    if (a === "cancel-book" && confirm(pt("cancel_question")))
      await manageBooking("cancel");
    if (a === "reschedule") {
      const r = pub.manage;
      pub.book = {
        stage: 0,
        interest: r.interest,
        name: r.name,
        phone: r.phone,
        date: "",
        start: "",
        slots: [],
        contact_consent: true,
        rescheduling: true,
      };
      drawBook();
      lockRescheduleFields();
    }
    if (a === "manage-send") await manageBooking("reschedule", pub.book.start);
  } catch (err) {
    bookError(err);
  } finally {
    el.disabled = false;
  }
});
document.addEventListener("input", (e) => {
  if (e.target.closest("#public-book-form")) rememberBooking();
});
document.addEventListener("change", async (e) => {
  if (e.target.name === "date" && e.target.closest("#public-book-form")) {
    try {
      await loadSlots(e.target.value);
    } catch (err) {
      bookError(err);
    }
  }
});
document.addEventListener("submit", async (e) => {
  if (e.target.id === "public-search") {
    e.preventDefault();
    pub.query = e.target.elements.q.value;
    pub.product = null;
    history.replaceState({}, "", pCatalogBase);
    try {
      await catalogFetch();
    } catch (err) {
      $p("#public-results").innerHTML =
        `<p class="notice error">${pe(err.message)}</p>`;
    }
  }
  if (e.target.id === "public-book-form") {
    e.preventDefault();
    rememberBooking();
    pub.book.stage = 1;
    drawBook();
    if (pub.book.rescheduling) {
      $p('[data-pub="book-send"]').dataset.pub = "manage-send";
    }
  }
});
$p("#booking-dialog").addEventListener("cancel", (e) => {
  if (pub.pending) {
    e.preventDefault();
    bookError(new Error(pt("unknown")));
  } else if (
    pub.book &&
    (pub.book.name || pub.book.phone) &&
    !confirm(pt("discard"))
  )
    e.preventDefault();
});
window.addEventListener("beforeunload", (e) => {
  if (pub.pending || (pub.book && (pub.book.name || pub.book.phone))) {
    e.preventDefault();
    e.returnValue = "";
  }
});
async function startPublic() {
  if(location.pathname==='/catalog/preview/'){
    publicMount.innerHTML='<p class="wrap">Preparing customer preview…</p>';
    window.addEventListener('message',e=>{
      if(e.origin!==location.origin||e.source!==window.parent||e.data?.type!=='smart-wholesale-product-preview')return;
      const product=e.data.product;if(!product||!Array.isArray(product.images)||typeof product.title_en!=='string')return;
      if(!e.data.config||typeof e.data.config.business_name!=='string')return;pub.config=e.data.config;pub.lang=e.data.lang==='zh'?'zh':'en';renderProduct(product);
    });
    window.parent.postMessage({type:'smart-wholesale-preview-ready'},location.origin);return;
  }
  try {
    pub.config = await pa("/api/public/config");
    const id =
      (pApiOrigin
        ? new URLSearchParams(location.search).get("product")
        : null) ||
      location.pathname.match(/^\/catalog\/product\/([a-f0-9]{20})$/)?.[1];
    if (id) renderProduct(await pa("/api/public/product/" + id));
    else await catalogFetch();
    const match = location.hash.match(
      /^#booking=([A-F0-9]{16}):([a-f0-9]{64})$/,
    );
    if (match) {
      pub.manage = { reference: match[1], manage_token: match[2] };
      const r = await pa("/api/public/booking-manage", {
        ...pub.manage,
        action: "view",
      });
      showConfirmation(r);
    }
  } catch (e) {
    if (pub.config)
      frame(
        `<p class="notice error">${pe(e.message)}</p>${pb("retry", "retry")}`,
      );
    else
      $p("#public-app").innerHTML =
        `<div class="wrap"><p class="notice error">${pe(e.message)}</p>${pb("retry", "retry")}</div>`;
  }
}
function catalogURL(offset) {
  return (
    "/api/public/products?q=" +
    encodeURIComponent(pub.query) +
    "&category=" +
    encodeURIComponent(pub.category) +
    "&sort=" +
    encodeURIComponent(pub.sort) +
    "&in_stock=" +
    (pub.inStock ? "1" : "0") +
    "&offset=" +
    offset
  );
}
async function refreshPublic() {
  if (
    document.hidden ||
    $p("#booking-dialog").open ||
    !pub.config ||
    pub.refreshing
  )
    return;
  pub.refreshing = true;
  const sequence = pub.sequence;
  try {
    const config = await pa("/api/public/config");
    if (sequence !== pub.sequence) return;
    const configChanged = JSON.stringify(config) !== JSON.stringify(pub.config);
    pub.config = config;
    if (pub.product) {
      const id = pub.product.id;
      try {
        const product = await pa("/api/public/product/" + id);
        if (pub.product?.id === id && sequence === pub.sequence)
          renderProduct(product);
      } catch (err) {
        if (err.code !== "not_found") throw err;
        if (pub.product?.id === id) {
          pub.product = null;
          history.replaceState({}, "", pCatalogBase);
          await catalogFetch();
        }
      }
    } else {
      const version = await pa("/api/public/catalog-version");
      if (sequence !== pub.sequence || pub.product) return;
      if (version.revision === pub.catalogRevision && !configChanged) return;
      const target = Math.max(24, pub.items.length);
      let items = [],
        offset = 0,
        last;
      do {
        last = await pa(catalogURL(offset));
        if (sequence !== pub.sequence || pub.product) return;
        if (last.catalog_revision !== version.revision) return;
        items.push(...last.products);
        offset = last.next_offset;
      } while (offset !== null && items.length < target);
      const search = $p("#public-search input"),
        value = search?.value,
        focused = document.activeElement === search,
        position = window.scrollY;
      pub.items = [...new Map(items.map((p) => [p.id, p])).values()];
      pub.offset = offset;
      pub.categories = last.categories || [];
      pub.total = last.total;
      pub.catalogRevision = version.revision;
      renderCatalog();
      if (search) {
        const next = $p("#public-search input");
        next.value = value;
        if (focused) next.focus({ preventScroll: true });
      }
      window.scrollTo?.(0, position);
      $p("#availability-checked").textContent =
        pt("checked") +
        ": " +
        dateLA(Date.parse(last.checked_at) / 1000) +
        ". " +
        pt("stock_note");
    }
    $p("#public-status").textContent = "";
  } catch (e) {
    $p("#public-status").textContent =
      pub.lang === "zh"
        ? "更新暂时失败，正在显示上次资料，稍后自动重试。"
        : "Update delayed. Showing the last loaded details; we’ll retry shortly.";
  } finally {
    pub.refreshing = false;
  }
}
setInterval(refreshPublic, 30000);
document.addEventListener("visibilitychange", () => {
  if (!document.hidden) refreshPublic();
});

document.addEventListener("click", async (e) => {
  const el = e.target.closest('[data-pub="department"]');
  if (!el) return;
  pub.category = el.dataset.category;
  pub.product = null;
  try {
    await catalogFetch();
    history.replaceState({}, "", pCatalogBase);
  } catch (err) {
    $p("#public-status").textContent = err.message;
  }
});
let wholesaleDraft = null;
function drawWholesale(p) {
  wholesaleDraft = { product: p, pending: null };
  const tr = (en, zh) => (pub.lang === "zh" ? zh : en),
    c = pub.config;
  const msg = `Hello, I would like wholesale pricing for ${pv(p, "title")} (SKU: ${p.sku}). ${new URL(productHref(p.id), location.origin).href}`;
  $p("#booking-body").innerHTML =
    `<div class="dialog-head"><h2>${pe(tr("Request wholesale pricing", "咨询批发价"))}</h2><button data-pub="wholesale-close" type="button">${pe(pt("close"))}</button></div><p><strong>${pe(pv(p, "title"))}</strong><br>${pe(p.sku)}</p>${c.phone ? `<div class="actions">${c.sms_enabled ? `<a class="button primary" href="sms:${pe(c.phone)}?body=${encodeURIComponent(msg)}">${pe(tr("Text us about this item", "发短信咨询此商品"))}</a>` : ""}<a class="button" href="tel:${pe(c.phone)}">${pe(pt("call"))}</a></div>` : ""}<p>${pe(tr("Or leave your number and our team will contact you.", "也可留下电话号码，由我们的团队与您联系。"))}</p><form id="wholesale-form"><label>${pe(pt("name"))}<input name="name" autocomplete="name" required maxlength="100"></label><label>${pe(tr("Phone number", "电话号码"))}<input name="phone" type="tel" autocomplete="tel" required maxlength="40"></label><details><summary>${pe(tr("More details (optional)", "更多资料（选填）"))}</summary><label>${pe(tr("Business name", "公司名称"))}<input name="business" maxlength="160" autocomplete="organization"></label><label>${pe(tr("Quantity you are interested in", "感兴趣的数量"))}<input name="quantity" maxlength="80" inputmode="numeric"></label><label>${pe(tr("Your message", "留言"))}<textarea name="message" maxlength="600"></textarea></label></details><label class="honeypot" aria-hidden="true">Website<input name="website" tabindex="-1" autocomplete="off"></label><label class="check"><input type="checkbox" name="contact_consent" required><span>${pe(tr("You may call or text me about this pricing request.", "同意就本次价格咨询致电或短信联系我。"))}</span></label><p class="small muted">${pe(tr("This request does not reserve stock, place an order, or sign you up for marketing.", "此咨询不会预留库存、创建订单或订阅营销信息。"))}</p><p id="wholesale-error" role="alert" class="notice error" hidden></p><button class="primary" type="submit">${pe(tr("Send pricing request", "发送询价"))}</button></form>`;
  $p("#booking-dialog").showModal();
}
document.addEventListener("click", async (e) => {
  const el = e.target.closest("[data-pub]");
  if (!el) return;
  if (el.dataset.pub === "wholesale") {
    try {
      const p =
        pub.product?.id === el.dataset.product
          ? pub.product
          : pub.items.find((p) => p.id === el.dataset.product) ||
            (await pa("/api/public/product/" + el.dataset.product));
      drawWholesale(p);
    } catch (err) {
      $p("#public-status").textContent = err.message;
    }
  }
  if (el.dataset.pub === "wholesale-close") {
    if (wholesaleDraft?.sending) return;
    const f = $p("#wholesale-form");
    if (
      f &&
      (f.elements.name.value || f.elements.phone.value) &&
      !confirm(pt("discard"))
    )
      return;
    wholesaleDraft = null;
    $p("#booking-dialog").close();
  }
});
document.addEventListener("submit", async (e) => {
  if (e.target.id !== "wholesale-form") return;
  e.preventDefault();
  if (wholesaleDraft.sending) return;
  const f = e.target,
    b = Object.fromEntries(new FormData(f));
  b.contact_consent = b.contact_consent === "on";
  b.product_id = wholesaleDraft.product.id;
  const fingerprint = JSON.stringify(b);
  if (
    !wholesaleDraft.pending ||
    wholesaleDraft.pending.fingerprint !== fingerprint
  )
    wholesaleDraft.pending = { fingerprint, key: crypto.randomUUID() };
  b.idempotency_key = wholesaleDraft.pending.key;
  wholesaleDraft.sending = true;
  f.querySelector("button[type=submit]").disabled = true;
  try {
    const r = await pa("/api/public/wholesale-request", b);
    $p("#booking-body").innerHTML =
      `<h2>${pe(pub.lang === "zh" ? "询价已发送" : "Pricing request sent")}</h2><p>${pe(pub.lang === "zh" ? "我们的团队会与您联系。" : "Our team will contact you.")}</p><p>${pe(pt("reference"))}: ${pe(r.reference)}</p><button type="button" data-pub="wholesale-close">${pe(pt("close"))}</button>`;
    wholesaleDraft = null;
  } catch (err) {
    $p("#wholesale-error").hidden = false;
    $p("#wholesale-error").textContent = err.message;
    wholesaleDraft.sending = false;
    f.querySelector("button[type=submit]").disabled = false;
  }
});
document.addEventListener("change", async (e) => {
  if (!["public-category", "public-sort", "public-stock"].includes(e.target.id))
    return;
  pub.category = $p("#public-category").value;
  pub.sort = $p("#public-sort").value;
  pub.inStock = $p("#public-stock").checked;
  try {
    await catalogFetch();
  } catch (err) {
    $p("#public-status").textContent = err.message;
  }
});
document.addEventListener("click", async (e) => {
  const a = e.target.closest("#public-app a[href]");
  if (!a || e.button > 0 || e.ctrlKey || e.metaKey || e.shiftKey || a.target)
    return;
  const u = new URL(a.href, location.origin);
  if (u.origin !== location.origin || u.hash) return;
  const id =
    u.searchParams.get("product") ||
    u.pathname.match(/^\/catalog\/product\/([a-f0-9]{20})$/)?.[1];
  if (!id && u.pathname !== pCatalogBase) return;
  e.preventDefault();
  try {
    if (id) {
      pub.listScroll = window.scrollY;
      const p = await pa("/api/public/product/" + id);
      history.pushState({ catalog: true }, "", u.pathname + u.search);
      renderProduct(p);
      window.scrollTo?.(0, 0);
    } else {
      history.pushState(
        { catalog: true },
        "",
        pCatalogBase +
          (new URLSearchParams(location.search).get("preview_theme_id")
            ? "?preview_theme_id=" +
              new URLSearchParams(location.search).get("preview_theme_id")
            : ""),
      );
      renderCatalog();
      window.scrollTo?.(0, pub.listScroll || 0);
    }
  } catch (err) {
    $p("#public-status").textContent = err.message;
  }
});
window.addEventListener("popstate", () => {
  const id =
    new URLSearchParams(location.search).get("product") ||
    location.pathname.match(/^\/catalog\/product\/([a-f0-9]{20})$/)?.[1];
  if (id)
    pa("/api/public/product/" + id)
      .then(renderProduct)
      .catch((err) => ($p("#public-status").textContent = err.message));
  else renderCatalog();
});
startPublic();
